// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'frentes.page.title': 'Frentes de trabalho',
    'frentes.page.search': 'Buscar frentes...',
    'frentes.page.filter.situacao': 'Situação',
    'frentes.page.filter.todas': 'Todas',
    'frentes.page.recorte.todos': 'Todas',
    'frentes.page.recorte.gct': 'Campo',
    'frentes.page.recorte.tms': 'Transporte',
    'frentes.page.recorte.ambos': 'Os dois',
    'frentes.page.col.frente': 'Frente',
    'frentes.page.col.apelido': 'Apelido',
    'frentes.page.col.campo': 'Trilho de campo',
    'frentes.page.col.transporte': 'Trilho de transporte',
    'frentes.page.col.contratoHub': 'Frente de trabalho',
    'frentes.page.col.origem': 'Origem',
    'frentes.page.col.situacao': 'Situação',
    'frentes.page.semStatus': 'Sem situação',
    'frentes.page.semTrilho': 'Sem este trilho',
    'frentes.page.semContrato': 'Sem frente de trabalho',
    'frentes.page.empty': 'Nenhuma frente neste recorte.',
    'frentes.page.emptySearch': 'Nenhuma frente para "{{query}}".',
    'frentes.page.resumo.sincronizacao': 'Última sincronização',
    'frentes.page.resumo.semSincronizacao': 'Ainda não sincronizado',
    'frentes.page.resumo.total': 'Total',
    'frentes.page.resumo.comCampo': 'Com campo',
    'frentes.page.resumo.comTransporte': 'Com transporte',
    'frentes.page.resumo.comOsDois': 'Com os dois',
    'frentes.page.resumo.vinculadas': 'Vinculadas no Hub',
    'frentes.page.detalhe.eyebrow': 'Frente de trabalho do Protheus',
    'frentes.page.detalhe.apelido': 'Apelido',
    'frentes.page.detalhe.dupla': 'Código da dupla',
    'frentes.page.detalhe.sincronizado': 'Sincronizado em',
    'frentes.page.detalhe.contratoHub': 'Frente de trabalho do Hub',
    'frentes.page.detalhe.trilhoCampo': 'Trilho de campo',
    'frentes.page.detalhe.trilhoTransporte': 'Trilho de transporte',
    'frentes.page.detalhe.contrato': 'Contrato',
    'frentes.page.detalhe.subcontrato': 'Subcontrato',
    'frentes.page.detalhe.devedor': 'Devedor',
    'frentes.page.detalhe.filial': 'Filial',
    'frentes.page.detalhe.linhaDoTempo': 'Linha do tempo, {{total}} ocorrências',
    'frentes.page.detalhe.semOcorrencia': 'A origem não trouxe ocorrência para esta frente.',
    'frentes.page.detalhe.fechar': 'Fechar',
    'frentes.page.ocorrencia.data': 'Agendamento',
    'frentes.page.ocorrencia.motorista': 'Motorista',
    'frentes.page.ocorrencia.veiculo': 'Veículo',
    'frentes.page.ocorrencia.reboque': 'Reboque',
    'frentes.page.ocorrencia.viagem': 'Viagem',
    'frentes.page.ocorrencia.statusViagem': 'Situação da viagem',
    'frentes.page.ocorrencia.operador': 'Operador',
    'frentes.page.ocorrencia.maquina': 'Máquina',
    'frentes.page.ocorrencia.tipoMaquina': 'Tipo de máquina',
    'frentes.page.ocorrencia.pedagio': 'Pedágio',
    'frentes.page.ocorrencia.pedagioSim': 'Sim',
    'frentes.page.ocorrencia.pedagioNao': 'Não',
    'frentes.page.ocorrencia.statusPedagio': 'Status do vale pedágio',
    'frentes.page.ocorrencia.medicao': 'Medição',
    'frentes.page.ocorrencia.notas': 'Notas',
    'frentes.page.ocorrencia.cte': 'CTe',
    'frentes.page.ocorrencia.mdfe': 'MDFe',
  },
  en: {
    'frentes.page.title': 'Work fronts',
    'frentes.page.search': 'Search work fronts...',
    'frentes.page.filter.situacao': 'Status',
    'frentes.page.filter.todas': 'All',
    'frentes.page.recorte.todos': 'All',
    'frentes.page.recorte.gct': 'Field',
    'frentes.page.recorte.tms': 'Transport',
    'frentes.page.recorte.ambos': 'Both',
    'frentes.page.col.frente': 'Front',
    'frentes.page.col.apelido': 'Label',
    'frentes.page.col.campo': 'Field track',
    'frentes.page.col.transporte': 'Transport track',
    'frentes.page.col.contratoHub': 'Hub work front',
    'frentes.page.col.origem': 'Source',
    'frentes.page.col.situacao': 'Status',
    'frentes.page.semStatus': 'No status',
    'frentes.page.semTrilho': 'Track absent',
    'frentes.page.semContrato': 'No Hub work front',
    'frentes.page.empty': 'No work fronts in this view.',
    'frentes.page.emptySearch': 'No work fronts for "{{query}}".',
    'frentes.page.resumo.sincronizacao': 'Last sync',
    'frentes.page.resumo.semSincronizacao': 'Not synced yet',
    'frentes.page.resumo.total': 'Total',
    'frentes.page.resumo.comCampo': 'With field',
    'frentes.page.resumo.comTransporte': 'With transport',
    'frentes.page.resumo.comOsDois': 'With both',
    'frentes.page.resumo.vinculadas': 'Linked in the Hub',
    'frentes.page.detalhe.eyebrow': 'Protheus work front',
    'frentes.page.detalhe.apelido': 'Label',
    'frentes.page.detalhe.dupla': 'Crew code',
    'frentes.page.detalhe.sincronizado': 'Synced at',
    'frentes.page.detalhe.contratoHub': 'Hub work front',
    'frentes.page.detalhe.trilhoCampo': 'Field track',
    'frentes.page.detalhe.trilhoTransporte': 'Transport track',
    'frentes.page.detalhe.contrato': 'Contract',
    'frentes.page.detalhe.subcontrato': 'Subcontract',
    'frentes.page.detalhe.devedor': 'Payer',
    'frentes.page.detalhe.filial': 'Branch',
    'frentes.page.detalhe.linhaDoTempo': 'Timeline, {{total}} entries',
    'frentes.page.detalhe.semOcorrencia': 'The source sent no entries for this front.',
    'frentes.page.detalhe.fechar': 'Close',
    'frentes.page.ocorrencia.data': 'Scheduled',
    'frentes.page.ocorrencia.motorista': 'Driver',
    'frentes.page.ocorrencia.veiculo': 'Vehicle',
    'frentes.page.ocorrencia.reboque': 'Trailer',
    'frentes.page.ocorrencia.viagem': 'Trip',
    'frentes.page.ocorrencia.statusViagem': 'Trip status',
    'frentes.page.ocorrencia.operador': 'Operator',
    'frentes.page.ocorrencia.maquina': 'Machine',
    'frentes.page.ocorrencia.tipoMaquina': 'Machine type',
    'frentes.page.ocorrencia.pedagio': 'Toll',
    'frentes.page.ocorrencia.pedagioSim': 'Yes',
    'frentes.page.ocorrencia.pedagioNao': 'No',
    'frentes.page.ocorrencia.statusPedagio': 'Toll voucher status',
    'frentes.page.ocorrencia.medicao': 'Measurement',
    'frentes.page.ocorrencia.notas': 'Invoices',
    'frentes.page.ocorrencia.cte': 'CTe',
    'frentes.page.ocorrencia.mdfe': 'MDFe',
  },
  es: {
    'frentes.page.title': 'Frentes de trabajo',
    'frentes.page.search': 'Buscar frentes...',
    'frentes.page.filter.situacao': 'Situación',
    'frentes.page.filter.todas': 'Todas',
    'frentes.page.recorte.todos': 'Todas',
    'frentes.page.recorte.gct': 'Campo',
    'frentes.page.recorte.tms': 'Transporte',
    'frentes.page.recorte.ambos': 'Ambos',
    'frentes.page.col.frente': 'Frente',
    'frentes.page.col.apelido': 'Apodo',
    'frentes.page.col.campo': 'Vía de campo',
    'frentes.page.col.transporte': 'Vía de transporte',
    'frentes.page.col.contratoHub': 'Frente de trabajo',
    'frentes.page.col.origem': 'Origen',
    'frentes.page.col.situacao': 'Situación',
    'frentes.page.semStatus': 'Sin situación',
    'frentes.page.semTrilho': 'Sin esta vía',
    'frentes.page.semContrato': 'Sin frente de trabajo',
    'frentes.page.empty': 'Ninguna frente en este recorte.',
    'frentes.page.emptySearch': 'Ninguna frente para "{{query}}".',
    'frentes.page.resumo.sincronizacao': 'Última sincronización',
    'frentes.page.resumo.semSincronizacao': 'Aún no sincronizado',
    'frentes.page.resumo.total': 'Total',
    'frentes.page.resumo.comCampo': 'Con campo',
    'frentes.page.resumo.comTransporte': 'Con transporte',
    'frentes.page.resumo.comOsDois': 'Con ambos',
    'frentes.page.resumo.vinculadas': 'Vinculadas en el Hub',
    'frentes.page.detalhe.eyebrow': 'Frente de trabajo del Protheus',
    'frentes.page.detalhe.apelido': 'Apodo',
    'frentes.page.detalhe.dupla': 'Código de la dupla',
    'frentes.page.detalhe.sincronizado': 'Sincronizado el',
    'frentes.page.detalhe.contratoHub': 'Frente de trabajo del Hub',
    'frentes.page.detalhe.trilhoCampo': 'Vía de campo',
    'frentes.page.detalhe.trilhoTransporte': 'Vía de transporte',
    'frentes.page.detalhe.contrato': 'Contrato',
    'frentes.page.detalhe.subcontrato': 'Subcontrato',
    'frentes.page.detalhe.devedor': 'Deudor',
    'frentes.page.detalhe.filial': 'Sucursal',
    'frentes.page.detalhe.linhaDoTempo': 'Línea de tiempo, {{total}} ocurrencias',
    'frentes.page.detalhe.semOcorrencia': 'El origen no trajo ocurrencias para esta frente.',
    'frentes.page.detalhe.fechar': 'Cerrar',
    'frentes.page.ocorrencia.data': 'Agendamiento',
    'frentes.page.ocorrencia.motorista': 'Conductor',
    'frentes.page.ocorrencia.veiculo': 'Vehículo',
    'frentes.page.ocorrencia.reboque': 'Remolque',
    'frentes.page.ocorrencia.viagem': 'Viaje',
    'frentes.page.ocorrencia.statusViagem': 'Situación del viaje',
    'frentes.page.ocorrencia.operador': 'Operador',
    'frentes.page.ocorrencia.maquina': 'Máquina',
    'frentes.page.ocorrencia.tipoMaquina': 'Tipo de máquina',
    'frentes.page.ocorrencia.pedagio': 'Peaje',
    'frentes.page.ocorrencia.pedagioSim': 'Sí',
    'frentes.page.ocorrencia.pedagioNao': 'No',
    'frentes.page.ocorrencia.statusPedagio': 'Estado del vale de peaje',
    'frentes.page.ocorrencia.medicao': 'Medición',
    'frentes.page.ocorrencia.notas': 'Notas',
    'frentes.page.ocorrencia.cte': 'CTe',
    'frentes.page.ocorrencia.mdfe': 'MDFe',
  },
}
